// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"adminPage_parentContainer__24WOC","childContainer":"adminPage_childContainer__51Uuc","nav":"adminPage_nav__3aJHU"};